import { isEmpty } from 'lodash'
import { IPricesAccepted } from '../../../actions/price/pricesAccepted'

export default function(store, action: IPricesAccepted) {
  return {
    ...store,
    prices:
      isEmpty(action.selectedRooms) || isEmpty(store.prices)
        ? action.prices
        : [
            ...store.prices.filter(
              p => !action.selectedRooms.includes(+p.roomId),
            ),
            ...action.prices,
          ],
  }
}
